import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Route, Redirect, useLocation } from "react-router-dom";
import ROUTES from "../routesConstants";
import * as RouteAction from "../store/route/actions";
import { Auth } from "aws-amplify";
import ROLES from '../routes/routes.tsx'

export default ({ component: C, props: cProps, ...rest }) => {
  const dispatch = useDispatch();
  const mapState = useCallback(
    state => ({
      typeHeader: state.header.typeHeader,
      payload: state.header.typeHeader,
      isAuthenticatedRedux: state.user.isAuthenticated,
      userData: state.user.user
    }),
    []
  );
  let location = useLocation();
  const { userData} = useMappedState(mapState);
  console.log("location",location)
  let rolesDelUsuarioLogueado = userData.roles;
  console.log("rolesDelUsuarioLogueado",rolesDelUsuarioLogueado)
  // Segun el orden que aparece en el array de ROLES. 
  let locationPermited = false;
  let rolDominante;
   
  if(rolesDelUsuarioLogueado){
     rolDominante = ROLES.filter(item=>rolesDelUsuarioLogueado.includes(item.name))
     
     if(rolDominante.length > 0){
       locationPermited = (rolDominante[0].routes.map(item=>item.path)).includes(location.pathname)
       console.log("rolDominante[0].routes.map(item=>item.path))",rolDominante[0].routes.map(item=>item.path))
       console.log("location.pathname",location.pathname)
       console.log("locationPermited",locationPermited)
     }
  }




  console.log("cProps.isAuthenticated", cProps.isAuthenticated);
  console.log("cProps.isRegisterBusiness", cProps.isRegisterBusiness);
  console.log("location.pathname", location.pathname);
  console.log("[cProps]", cProps);
  // let path = location.pathname
  // dispatch(RouteAction.set(path));
  useEffect(() => {
  
    console.log("Ha habido un cambio");
    let path = location.pathname;
    dispatch(RouteAction.set(path));
    
  }, [location.pathname]);

  // const [isAuthenticated,setAuthenticated]=useState(false);

  // const getAuthenticated = async()=>{
  //   console.log("[getAuthenticated]")
  //   try{
  //     const session = await Auth.currentSession();
  //     console.log("session",session)
  //     setAuthenticated(true);
  //     console.log("isAuthenticated",isAuthenticated)
  //   }catch{
  //     console.log("No esta logeado")
  //     setAuthenticated(false);
  //   }
  // }
  // useEffect(() => {
  //   getAuthenticated();
  // }, [])

  // cProps.isRegisterBusiness
  return (
    <Route
      {...rest}
      render={props =>
        cProps.isAuthenticated && locationPermited? (
          cProps.isRegisterBusiness ||
          location.pathname == ROUTES.OLD_BUSINESS_REGISTER ? (
            location.pathname == ROUTES.ROOT ? (
              <Redirect to={`${ROUTES.ROOT_AUTH}`} />
            ) : (
              <C {...props} {...cProps} />
            )
          ) : (
            <Redirect to={`${ROUTES.OLD_BUSINESS_REGISTER}`} />
          )
        ) : (
          <Redirect
            // to={`${ROUTES.LOGIN}?redirect=${props.location.pathname}${props.location
            //     .search}`}
            to={`${ROUTES.LOGIN}`}
          />
        )
      }
    />
  );
};
